import { RefObject, useEffect, useRef } from 'react';

export const useAddBodyPadding = (menuRef: RefObject<HTMLElement>, isSticky: boolean) => {
  const hasPaddingBeenAdded = useRef(false);

  useEffect(() => {
    if (!menuRef.current || hasPaddingBeenAdded.current) return;

    if (isSticky) {
      const originalPadding = window.getComputedStyle(document.body).paddingBottom;
      const originalValue = parseFloat(originalPadding) || 0;

      document.body.style.paddingBottom = `${originalValue + menuRef.current.offsetHeight}px`;
      hasPaddingBeenAdded.current = true;
    }
  }, [isSticky, menuRef]);
};
